export enum GiftType {
  code = 'code',
  gift = 'gift',
  alyceCard = 'alyceCard',
}
